import {AbsoluteCenter, Flex} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PageTitle from '../WooorldInApp/PageTitle';
import {AdvancedMarker, APIProvider, useMapsLibrary} from '@vis.gl/react-google-maps';
import {MapRenderer} from '../WooorldInApp/Minimap/MapRenderer';
import GooodMapControls from './GooodMapControls';
import {worldSet} from '../../reducers/inAppReducer';
import PinIcon from '../WooorldInApp/Minimap/PinIcon';
import useStreetViewService from '../../hooks/useStreetViewService';


const GooodPins = ({pins}) => {
  const streetViewLib = useMapsLibrary('streetView');
  const streetViewService = useStreetViewService();

  return (
    <>
      {pins.map((pin, idx) => {
        const {
          location: {Latitude: lat, Longitude: lng},
          isInPrivateFolder,
          isInSharedFolder,
          numPins,
          panoId, // witw pin
          streetViewId,
          streetViewIdIsApi2025,
          zoomToExpand,
        } = pin;

        console.log(pin);

        return (
          <AdvancedMarker
            key={idx}
            onClick={(e) => {
              e.stop();
            }}
            position={{lat, lng}}
          >
            <AbsoluteCenter pointerEvents="none">
              <PinIcon
                isPrivate={isInPrivateFolder}
                isShared={isInSharedFolder}
                onClick={(e) => {
                  if (!streetViewLib) {
                    console.warn('streetViewLib not loaded');
                    return;
                  }
                  const pano = new streetViewLib.StreetViewPanorama(
                    document.getElementById('pano'),
                    {
                      position: {
                        lat,
                        lng,
                      },
                    },
                  );
                }}
                pin={pin}
                size="5em"
                streetViewId={streetViewId || panoId}
              />
            </AbsoluteCenter>

          </AdvancedMarker>
        );
      })}
    </>
  )
}


const GooodMap = () => {
  const {googleMapsWooorld, demoWorldId} = useSelector(s => s.goood.auth.response);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!demoWorldId) return;
    dispatch(worldSet({_id: demoWorldId}));
  }, [demoWorldId]);


  const [pins, setPins] = useState([]);

  return (
    <Flex
      w="full"
      h="80vh"
      direction="column"
    >
      <PageTitle title="Map Data - Goood"/>

      <GooodMapControls
        demoWorldId={demoWorldId}
        setPins={setPins}
      />

      <Flex bg="blue" grow={1}>
        <APIProvider apiKey={googleMapsWooorld}>
          <MapRenderer h="full" w="full">

            <GooodPins pins={pins} />

          </MapRenderer>
        </APIProvider>
      </Flex>

      <Flex id="pano" bg="black" w="full" grow={0.5}>

      </Flex>

    </Flex>);
};

export default GooodMap;
